<div class="row hideonprint utils-bar">
  <div class="table-filter">
    @if (search) {
      <form (submit)="relaySearchSubmitted()" class="row center">
        <div class="row center" style="position:relative;">
          <input [(ngModel)]="searchValue" name="filter" class="table-filter-input" placeholder="Search table"
            [disabled]="disabled"
            (keyup)="relaySearchValueChanged()"/>
          <mat-icon (click)="!disabled && relaySearchCleared();"
            [ngClass]="{'clear-disabled': disabled || searchValue?.length < 1}"
            class="search-clear" matTooltip="Reset table" [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY">
            clear
          </mat-icon>
        </div>
        <div class="row center">
          @if (userSearchFields && sortByArray) {
            <select-many-filter
              [disabled]="disabled || !userSearchFields?.length"
              (constant_changed)="relaySearchSelectionsChanged($event)"
              [modelValue]="userSearchSelections"
              [options]="userSearchFields"
              [placeholder]="'Select columns'"
              [listType]="'columns'"
              >
            </select-many-filter>
          }
        </div>
        @if (search) {
          <button type="submit" [disabled]="disabled || !searchValue" mat-flat-button
            class="search-button" color="accent">
            <i class="fa fa-search"></i>
          </button>
        }
      </form>
    }

  </div>
</div>
